import { useCallback, useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Bar, Doughnut, Pie } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import caseLogService from "api/casesAPI";
import { format } from "date-fns";
import { Oval } from "react-loader-spinner";
Chart.register(...registerables, ChartDataLabels);
const Statistics = () => {
  const date = new Date();
  const [dateRange, setDateRange] = useState([
    new Date(date.getFullYear(), date.getMonth(), 1),
    new Date(date.getFullYear(), date.getMonth() + 1, 0),
  ]);
  const [startDate, endDate] = dateRange;
  const [data, setData] = useState([]);

  const [categoryCounts, setCategoryCounts] = useState([]);
  const [zoneCounts, setZoneCounts] = useState([]);
  const [incidentTypeCounts, setIncidentTypeCounts] = useState([]);
  const [lossRecoveryCounts, setLossRecoveryCounts] = useState([]);
  const [loading, setLoading] = useState(false);

  let datasetColors = ["#f47e19", "#00aea3", "#bece27", "#FF6384", "#36A2EB"];
  const getZoneCount = (filteredData) => {
    let arr = [];
    let counts = [];
    filteredData.forEach((item) => {
      if (!arr.includes(item.zone)) {
        arr.push(item.zone);
      }
    });

    arr.forEach((item) => {
      let count = 0;
      filteredData.forEach((dt) => {
        if (dt.zone === item) {
          count++;
        }
      });
      counts.push({
        zone: item,
        count: count,
      });
    });

    setZoneCounts(counts);
  };

  const getLossRecoveryCount = (filteredData) => {
    let arr = {};
    let loss = 0;
    let recovery = 0;
    filteredData.forEach((item) => {
      if (item.loss) {
        let currency = item.loss;

        loss = Math.floor(loss + currency);
      }

      if (item.recovery) {
        let currency = item.recovery;

        recovery = Math.floor(recovery + currency);
      }
    });

    arr = { loss: loss, recovery: recovery };
    setLossRecoveryCounts(arr);
    // console.log("Total Loss", loss);
    // console.log("Total Recovery", recovery);
  };

  const getIncidentTypeCount = (filteredData) => {
    let arr = [];
    let counts = [];
    filteredData.forEach((item) => {
      if (!arr.includes(item.incidentType)) {
        arr.push(item.incidentType);
      }
    });

    arr.forEach((item) => {
      let count = 0;
      filteredData.forEach((dt) => {
        if (dt.incidentType === item) {
          count++;
        }
      });
      counts.push({
        incidentType: item,
        count: count,
      });
    });

    setIncidentTypeCounts(counts);
  };

  const getCategoryCount = (filteredData) => {
    let arr = [];
    let categories = [];
    filteredData.forEach((item) => {
      if (!arr.includes(item.category)) {
        arr.push(item.category);
      }
    });

    arr.forEach((item) => {
      let count = 0;
      filteredData.forEach((dt) => {
        if (dt.category === item) {
          count++;
        }
      });
      categories.push({
        category: item,
        count: count,
      });
    });

    setCategoryCounts(categories);
  };
  const getData = useCallback(async () => {
    // const filter = rangedData.filter(
    //   (item) =>
    //     new Date(item.date) >= startDate && new Date(item.date) <= endDate
    // );
    setLoading(true);
    const filter = await caseLogService
      .getCasesBetweenDates(
        format(new Date(startDate), "M/d/yyyy hh:mm:ss aa"),
        format(new Date(endDate), "M/d/yyyy hh:mm:ss aa")
      )
      .then((res) => {
        if (res.ok) {
          return res.data;
        } else return [];
      });

    setData(filter);
    getCategoryCount(filter);
    getIncidentTypeCount(filter);
    getZoneCount(filter);
    getLossRecoveryCount(filter);
    setLoading(false);
  }, [startDate, endDate]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div className=" w-full h-full flex flex-col">
      <div className="self-center py-2 flex flex-col  px-3 rounded w-fit">
        <div className="flex space-x-2 items-center">
          <FaCalendarAlt />

          <span>Select Date</span>
        </div>
        <DatePicker
          className="px-2   w-[240px] rounded bg-secondary "
          selectsRange={true}
          showYearDropdown
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => {
            setDateRange(update);
          }}
          dateFormat="d/M/yyyy"
          isClearable={true}
        />
      </div>

      <div className="flex flex-col  self-center px-5 py-2  text-base bg-secondary rounded w-fit  items-center justify-center">
        <span>Total Selected Cases</span>
        <span className="text-primary">{data.length}</span>
      </div>
      {loading && (
        <div className=" flex flex-col  flex-1 w-full h-screen justify-center items-center space-y-5 ">
          <Oval
            height={100}
            width={100}
            color="royalblue"
            secondaryColor="white"
          />
        </div>
      )}

      {!loading && (
        <>
          <div className="grid lg:grid-cols-2 grid-cols-1 grid-rows-1 gap-10  justify-items-center">
            <div className=" w-2/3 rounded">
              {zoneCounts && (
                <Pie
                  options={{
                    // indexAxis: "y",
                    plugins: {
                      legend: {
                        position: "top",
                      },
                      datalabels: {
                        color: "#fff",
                        // formatter: (val, ctx) => {
                        //   return ctx.chart.data.labels[ctx.dataIndex];
                        // },
                      },

                      title: {
                        display: true,
                        text: "Statistics by Zones",
                        color: "#fff",
                      },
                    },
                    color: "#fff",
                    scales: {
                      y: {
                        ticks: {
                          color: "#fff",
                          display: false,
                        },
                      },
                      x: {
                        ticks: {
                          color: "#fff",
                          display: false,
                        },
                      },
                    },
                  }}
                  data={{
                    labels: zoneCounts.map((item) => item.zone),
                    datasets: [
                      {
                        label: zoneCounts.map((item) => item.zone),
                        data: zoneCounts.map((item) => item.count),
                        backgroundColor: datasetColors,
                        borderColor: "transparent",
                      },
                    ],
                  }}
                />
              )}
            </div>
            <div className=" w-2/3 rounded">
              {lossRecoveryCounts && (
                <Doughnut
                  options={{
                    // indexAxis: "y",
                    plugins: {
                      legend: {
                        position: "top",
                      },
                      datalabels: {
                        color: "#fff",
                        formatter: (val, ctx) => {
                          return (
                            val &&
                            val
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " SAR "
                          );
                        },
                      },

                      title: {
                        display: true,
                        text: "Losses and Recoveries",
                        color: "#fff",
                      },
                    },
                    color: "#fff",
                    scales: {
                      y: {
                        ticks: {
                          color: "#fff",
                          display: false,
                        },
                      },
                      x: {
                        ticks: {
                          color: "#fff",
                          display: false,
                        },
                      },
                    },
                  }}
                  data={{
                    labels: ["Loss", "Recovery"],
                    datasets: [
                      {
                        label: ["Loss", "Recovery"],
                        data: [
                          lossRecoveryCounts.loss,
                          lossRecoveryCounts.recovery,
                        ],
                        backgroundColor: ["#FF6384", "#36A2EB"],
                        borderColor: "transparent ",
                      },
                    ],
                  }}
                />
              )}
            </div>

            <div className=" w-full   rounded">
              {categoryCounts && (
                <Bar
                  options={{
                    // indexAxis: "y",
                    plugins: {
                      legend: {
                        position: "top",
                      },
                      datalabels: {
                        color: "#fff",
                      },

                      title: {
                        display: true,
                        text: `Statistics by Category`,
                        color: "#fff",
                      },
                    },
                    color: "#fff",
                    scales: {
                      y: {
                        ticks: {
                          color: "#fff",
                          mirror: true,
                        },
                      },
                      x: {
                        ticks: {
                          color: "#fff",
                          display: false,
                          mirror: true,
                        },
                      },
                    },
                  }}
                  data={{
                    labels: ["Categories"],

                    datasets: categoryCounts.map((item, i) => {
                      return {
                        minBarLength: 10,
                        label: item.category,
                        backgroundColor: datasetColors[i],
                        borderColor: "rgba(255,255,255,0.5)",
                        borderWidth: 1,

                        data: [item.count],
                      };
                    }),
                  }}
                />
              )}
            </div>
          </div>
          {incidentTypeCounts && (
            <div className="text-xs grid grid-cols-4 gap-2 py-5">
              {incidentTypeCounts.map((item) => (
                <div key={item.caseNumber}>
                  {item.incidentType}:
                  <span className="text-primary font-bold text-sm">
                    {item.count}
                  </span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Statistics;
